export default [
  { value: 'theme-classic', label: 'Classic' },
  { value: 'theme-modern', label: 'Modern' },
];
